"use client";
import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { Placeholder } from '../Placeholder/Placeholder.web.js';
import { inPixels } from '../utils/helpers/style.js';

var _excluded = ["size"];
var Component = /*#__PURE__*/React.lazy(function () {
  return Promise.all([import('./LazyIconLoader.web.js')]).then(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      moduleExports = _ref2[0];
    return moduleExports;
  });
});
var LazyIcon = function LazyIcon(_ref3) {
  var _ref3$size = _ref3.size,
    sizeProp = _ref3$size === undefined ? 24 : _ref3$size,
    props = _objectWithoutProperties(_ref3, _excluded);
  var size = inPixels(sizeProp);
  return /*#__PURE__*/React.createElement(React.Suspense, {
    "data-testid": "elemental-LazyIcon",
    fallback: /*#__PURE__*/React.createElement(Placeholder, {
      height: size,
      width: size
    })
  }, /*#__PURE__*/React.createElement(Component, _extends({
    size: size
  }, props)));
};

export { LazyIcon };
